import { styled } from 'styled-components';

import type { AppConfig } from '#/config/types/AppConfig';
import { cssBreakpoints } from '#/theme/theme';
import { imageUrl } from '#/utils/filestack';
import { hiDPI } from '#/utils/style';

export const CmsSignUpBlockHolder = styled.div<{
  $imageHandle: string | undefined;
  $mimetype: string | undefined;
  $appConfig: AppConfig;
}>`
  background-size: cover;
  background-position: center;
  ${({ $imageHandle, $mimetype, $appConfig: appConfig }) =>
    $imageHandle &&
    `
    background-image: url('${imageUrl({
      data: {
        handle: $imageHandle,
        mimetype: $mimetype,
      },
      width: 800,
      height: undefined,
      fit: 'max',
      insecureSVG: false,
      appConfig,
    })}');
    ${hiDPI()}: {
      background-image: url('${imageUrl({
        data: { handle: $imageHandle, mimetype: $mimetype },
        width: 1600,
        height: undefined,
        fit: 'max',
        insecureSVG: false,
        appConfig,
      })}');
    }
    @media all and (min-width: ${cssBreakpoints.lgUp}) {
      background-image: url('${imageUrl({
        data: { handle: $imageHandle, mimetype: $mimetype },
        width: 1280,
        height: undefined,
        fit: 'max',
        insecureSVG: false,
        appConfig,
      })}');
      ${hiDPI()}: {
        background-image: url('${imageUrl({
          data: { handle: $imageHandle, mimetype: $mimetype },
          width: 2560,
          height: undefined,
          fit: 'max',
          insecureSVG: false,
          appConfig,
        })}');
      }
    }
  `}
`;
